export const url = "https://api-uk.kurtosys.app/readme/";
